import type { SpringboardCategoriesResponseDto } from '@/shared/api/springboard-categories.api';
import type { CategoryItem } from '@/shared/types/tool-categories.types';

export const applyCategoryLabelOverrides = (
  categories: CategoryItem[],
  customization?: SpringboardCategoriesResponseDto,
): CategoryItem[] => {
  if (!customization?.hasCustomization || !customization.categories?.length) {
    return categories;
  }

  const labelById = new Map(
    customization.categories.map((category) => [category.id, category.label]),
  );

  return categories.map((category) => {
    const customLabel = labelById.get(
      category.id as (typeof customization.categories)[number]['id'],
    );
    return customLabel?.trim() ? { ...category, label: customLabel } : category;
  });
};
